/**
 * Markers for the hidden text part that carries per-message workspace context
 * (file snapshots for the agent to read).
 *
 * The composer emits it and the transcript skips it, so the tags live with the
 * chat shell. A host's server reduces the same message to user-visible text
 * (chat titles, previews, export) and imports these from here rather than
 * spelling the tag a second time.
 */
export const CONTEXT_OPEN_TAG = "<workspace_context>";
export const CONTEXT_CLOSE_TAG = "</workspace_context>";

/** True for a text part whose contents are a `<workspace_context>` block. */
export function isContextTextPart(text: string): boolean {
  return text.trimStart().startsWith(CONTEXT_OPEN_TAG);
}
